import { FC, useState } from 'react';
import { VideoJsPlayer } from 'video.js';

import {
  ILecturePlayer,
  LecturePlayerProvider,
} from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer.context';

export const LecturePlayer: FC<ILecturePlayer> = ({ children }) => {
  const context = useState<VideoJsPlayer | null>(null);

  return <LecturePlayerProvider value={context}>{children}</LecturePlayerProvider>;
};
